'use strict';

var CellLinkRendererFactory = function CellLinkRendererFactory($interpolate) {
  var messageTemplate = $interpolate('<a href="#" data-click="true" uid="{{uid}}" field-id="{{fieldId}}">{{linkText}}</a>');
  var cellLinkRenderer = function cellLinkRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var data = {
      uid: row,
      fieldId: columnfield,
      linkText: columnContext.columnMetadata.linkText
    };
    return defaultvalue.replace('>' + value + '<', '>' + messageTemplate(data) + '<');
  };
  return {
    cellLink: cellLinkRenderer
  };
};
CellLinkRendererFactory.$inject = ['$interpolate'];
module.exports = CellLinkRendererFactory;